// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b57f42e3af9afa40","5405":"d4051a2f8d9004b4"}[chunkId] + ".css";
};